module.exports = __webpack_public_path__ + "media/mobilefollow.75b7ce3a.mp4";